import { Session } from './session';
import getCsrSession from '@spa/lib/auth/getCsrSession';
import initializeCsrSession from './initializeCsrSession';

const getOrInitializeCsrSession = (): Session => {
  return getCsrSession() ?? initializeCsrSession();
};

export default getOrInitializeCsrSession;
